import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStackshareComponent } from './simple-icons-stackshare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStackshareComponent ],
    exports:      [ SimpleIconsStackshareComponent ],
    bootstrap:    []
})
export class SimpleIconsStackshareModule {}
